import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import { Helmet } from 'react-helmet';
import { isUndefined, isNull } from 'lodash';
import Classnames from 'classnames';

import './index.scss';
import { METADATA } from '../../constants';
import Navbar from '../../components/Navbar';
import { uploadContentService } from '../../services';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: "Helvetica Neue",
  },
  iconStyle:{
    fontSize:100,
  },
  paper: {
    backgroundColor: "#212529",
    minWidth:250,
    marginTop: 5,
    marginBottom:5,
    padding:5,
    '&:hover': {
      backgroundColor: "#fb8c00",
    },
  },
}));


export default function Dashboard() {
  const history = useHistory();
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [listDevices, setListDevices] = useState(JSON.parse(localStorage.getItem("devices")));
  const { user } = useSelector(state => state.userAuthentication);

  const getTaggedContentUnitList = useCallback(async (marker) => {
    if (!isUndefined(user)) {
      if (!isUndefined(marker)) {
        const res = await uploadContentService.taggedContentUnitList(user, marker);

        if (!isUndefined(res)) {
          const devices = JSON.parse(localStorage.getItem("devices"))['devices'];

          const newDevices = Object.values(res['devices']);

          if (!isUndefined(devices)) {
            newDevices.map(item => {
              return devices.push(item);
            });
          }

          res['devices'] = devices;

          localStorage.setItem("devices", JSON.stringify(res));
          setListDevices(res);
        }
      } else {
        const nextMarker = '';
        const res = await uploadContentService.taggedContentUnitList(user, nextMarker);

        if (!isUndefined(res)) {
          localStorage.setItem("devices", JSON.stringify(res));
          setListDevices(res);
        }
      }
    }
  }, [user]);

  useEffect(() => {
    getTaggedContentUnitList();
  }, [getTaggedContentUnitList]);

  if (!isUndefined(listDevices) && !isNull(listDevices)) {
    if (!isLoading) {
      if (listDevices?.isTruncated) {
        const marker = listDevices?.nextMarker;
        getTaggedContentUnitList(marker);
      }
    }
  }

  const handleRedirectToPage = (event) => {
    if (event.currentTarget.dataset.value === "upload-content") {
      history.push("/upload-content");
      // window.location.reload();
    } else if (event.currentTarget.dataset.value === "live-content") {
      history.push("/live-content");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "handle-tags") {
      history.push("/handle-tags");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "units-content") {
      history.push("/units");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "music") {
      history.push("/music");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "presentations") {
      history.push("/presentations");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "dynamic-playlist") {
      history.push("/dynamic-playlist");
      window.location.reload();
    }
  }

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.DASHBOARD.description} />
        <title>{METADATA.DASHBOARD.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center">
        <Grid
          item
          className="dashboard-content main-menu"
          justify="center"
          xs={11}
          md={8}
          lg={5}
          xl={12}
        >
          <div className="dashboard-title">
            <h1>WELCOME TO <span className="span-orange">INSTOREX</span></h1>
            <h5>Click on the boxes below to execute the desired request</h5>
          </div>
          <Grid container className="dashboard grid-items" justify="center" spacing={4}>
            {/* <Grid key="1" item>
              <Paper className="grid-paper">
                <div className="inner-content">
                  <CreateIcon />
                </div>
              </Paper>
            </Grid> */}
            <Grid key="2" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="upload-content">
                <div className="inner-content">
                  <PublishIcon  style={{fontSize:100}} />
                  <Grid className="titleNames">Upload Content</Grid>
                </div>
              </Paper>
            </Grid>
            <Grid key="3" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="live-content">
                <div className="inner-content">
                  <WifiTetheringIcon   style={{fontSize:100}} />
                  <Grid className="titleNames">Schedule Content</Grid>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <Grid container className="dashboard grid-items" justify="center" spacing={4}>
            <Grid key="4" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="handle-tags">
                <div className="inner-content">
                  <Grid> <LocalOfferIcon  style={{fontSize:100}} /></Grid>
                  <Grid className="titleNames"> Handle Tags</Grid>
                </div>
              </Paper>
            </Grid>
            <Grid key="5" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="music">
                <div className="inner-content">
                  <MusicNoteIcon  style={{fontSize:100}} />
                  <Grid className="titleNames"> Music</Grid>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <Grid container className="dashboard grid-items" justify="center" spacing={4}>
            <Grid key="6" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="units-content">
                <div className="inner-content">
                  <VideoLabelIcon  style={{fontSize:100}} />
                  <Grid className="titleNames"> Units</Grid>
                </div>
              </Paper>
            </Grid>
            <Grid key="7" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="presentations">
                <div className="inner-content">
                  <SlideshowIcon  style={{fontSize:100}} />
                  <Grid className="titleNames"> Presentations</Grid>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <Grid container className="dashboard grid-items" justify="center" spacing={4}>
            <Grid key="8" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="dynamic-playlist">
                <div className="inner-content">
                  <QueueMusicIcon  style={{fontSize:100}} />
                  <Grid className="titleNames"> Dynamic Playlist</Grid>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}